import { useTranslation } from "react-i18next";
import { cn } from "./lib/utils";

/** Baked into the bundle, so it still answers when the Api does not. */
export function Version({ className }: { className?: string }) {
  const { t } = useTranslation();

  // An unset build argument arrives as an empty string, not undefined.
  const version = import.meta.env.VITE_APP_VERSION || "dev";
  const commit = import.meta.env.VITE_APP_COMMIT || null;

  return (
    <p
      className={cn("text-xs text-muted-foreground", className)}
      title={commit ? t("version.commit", { commit }) : undefined}
      data-testid="version"
    >
      {t("version.label", { version })}
    </p>
  );
}
